export const POPULAR_POSTS_PATH = '/popular-posts';

export const POPULAR_POSTS_VIEW_PATH = '/popular-posts/posts';

export const POPULAR_POSTS_BAR_LABEL = 'Popular';

export const MAX_SHOWN_POST_IDS = 10000;

export const POPULAR_EMPTY_MESSAGE = 'Nothing new to discover';
